import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'
import _imports_1 from '../../../public/img/investorkits/23-investor_pdficon.png'


const _withScopeId = n => (_pushScopeId("data-v-fea944c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "committee-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-fea944c4><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-fea944c4><img src=\"" + _imports_0 + "\" alt=\"\" data-v-fea944c4><div style=\"display:flex;flex-direction:column;\" data-v-fea944c4><p style=\"color:#000;font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-fea944c4>INTERIM REPORTS</p></div></div></div>", 1)
const _hoisted_3 = { class: "press-content" }
const _hoisted_4 = { style: {"color":"#000"} }
const _hoisted_5 = ["item"]
const _hoisted_6 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"20px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_8 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","margin-bottom":"5px"} }
const _hoisted_9 = { style: {"color":"#000"} }
const _hoisted_10 = ["item"]
const _hoisted_11 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"20px"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_13 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","margin-bottom":"5px"} }
const _hoisted_14 = { style: {"color":"#000"} }
const _hoisted_15 = ["item"]
const _hoisted_16 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"20px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_18 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","margin-bottom":"5px"} }

import Footer from "@/components/home/Footer.vue";
import { ref, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Interim1',
  setup(__props, { expose }) {

const activeNames = ref(["1"]);
const handleChange = (val: string[]) => {
  console.log(val);
};

const datas1 = reactive([
  {
    name: "FD TECHNOLOGY INC. First Half of FY2021 Earnings Results",
  },
  {
    name: "FD TECHNOLOGY INC. First Half of FY2021 Earnings Conference Call Edited Transcri",
  },
  {
    name: "FD TECHNOLOGY INC. First Half of FY2021 Earnings Webcast",
  },
]);
const datas2 = reactive([
  {
    name: "FD TECHNOLOGY INC. First Half of FY2020 Earnings Results",
  },
  {
    name: "FD TECHNOLOGY INC. First Half of FY2020 Earnings Webcast",
  },
]);
const datas3 = reactive([
  {
    name: "FD TECHNOLOGY INC. First Half of FY2019 Earnings Results",
  },
]);


const isCollapsed = ref(false);

function toggleCollapse() {
  isCollapsed.value = !isCollapsed.value;
}

expose({ toggleCollapse });

const arrowClasses = {
  'collapse-arrow': true,
  'active': isCollapsed.value
};




return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_collapse, {
          modelValue: activeNames.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event)),
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: "2021",
              name: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas1, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      item: item
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("hr", {
                        style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas1.length - 1 ? 'none' : ''}])
                      }, null, 4)
                    ], 8, _hoisted_5))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "2020",
              name: "2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas2, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      item: item
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("hr", {
                        style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas2.length - 1 ? 'none' : ''}])
                      }, null, 4)
                    ], 8, _hoisted_10))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "2019",
              name: "3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas3, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      item: item
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("hr", {
                        style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas3.length - 1 ? 'none' : ''}])
                      }, null, 4)
                    ], 8, _hoisted_15))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})